// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3TRR_","footer":"ModalFilter_footer__kZ9fU"};